export default "__VITE_ASSET__BkGMzUrN__"